<template>
  <div class="row overflow-hidden text-center">
    <div class="col-4 mh-100 overflow-auto px-0">
      <div
        class="list-group text-left"
        role="tablist"
        aria-orientation="vertical"
      >
        <div v-for="(tab, index) of tabs" :key="index">
          <button
            v-for="([itemName, item]) in Object.entries(tab)"
            :id="tabSlot(itemName)"
            :key="itemName"
            :class="['list-group-item list-group-item-action', { active: isActive(itemName) }]"
            role="tab"
            :tabindex="skipTabs"
            :aria-selected="Object.keys(activeTab)[0] === itemName"
            :aria-controls="panelSlot(itemName)"
            @keydown.enter.prevent="quickSubmit(item)"
            @dblclick="quickSubmit(item)"
            @keydown="keydownHandler"
            @click="switchTab({[itemName]: item})"
            @focus="switchTab({[itemName]: item})"
          >
            {{ itemName }}
          </button>
        </div>
      </div>
    </div>
    <div :id="activeTabSlot" class="col-8 border-left mh-100 overflow-auto" role="tabpanel" :aria-labelledby="activePanelSlot">
      <!-- (2) -->
      <div class="tab-panel tab-content active-content">
        <slot name="default" :activeText="Object.values(activeTab)[0]" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TabPreview",
  // Vue 3:
  // emits: ['change'],
  props: { // (1)
    quickSubmit: Function, // todo: this could be a @event instead
    initialTab: {
      type: Object,
    },
    updateParentSelected: Function,
    tabs: {
      type: Array, // Array of objects in the format { uniqueShortName: 'actual text' }
      required: true,
    }
  },
  data() {
    return {
      activeTab: this.initialTab || this.tabs[0] // todo: could visually show it // (2)
    };
  },
  computed: {
    activePanelSlot() {
      return `panel-${Object.keys(this.activeTab)[0]}`;
      // (3)
    },
    activeTabSlot() {
      return `tab-${Object.keys(this.activeTab)[0]}`;
    },
    skipTabs(){
      return this.tabs.length === 1 ? -1 : 0;
    },
  },
  watch: {
    tabs: function (){
      this.activeTab = this.initialTab || this.tabs[0];
    },
    activeTab: function(value){
      this.$emit('change', Object.values(value)[0]);
    },
  },
  mounted() {
    this.$emit('change', Object.values(this.activeTab)[0]);
  },
  methods: {
    tabSlot(tabName) {
      return `tab-${tabName}`;
    },
    isActive(itemName) {
      return Object.keys(this.activeTab)[0] === itemName;
    },
    panelSlot(tabName) {
      return `panel-${tabName}`;
    },
    switchTab(tab) {
      this.activeTab = tab;
    },
    focusTab(tab){
      this.switchTab(tab);
      document.getElementById(this.tabSlot(Object.keys(this.activeTab)[0])).focus(); // (4)
    },
    keydownHandler(e) {
      const activeIndex = this.tabs.findIndex(item => Object.keys(item)[0] === Object.keys(this.activeTab)[0]); //6
      let targetTab = null;

      switch (e.key) {
        case "ArrowLeft":
        case "ArrowUp":
          if (activeIndex - 1 < 0) {
            targetTab = this.tabs[this.tabs.length - 1];
          } else {
            targetTab = this.tabs[activeIndex - 1];
          }
          this.focusTab(targetTab);
          e.preventDefault();
          break;
        case "ArrowRight":       // (7)
        case "ArrowDown":
          if (activeIndex + 1 > this.tabs.length - 1) {
            targetTab = this.tabs[0];
          } else {
            targetTab = this.tabs[activeIndex + 1];
          }
          this.focusTab(targetTab);
          e.preventDefault();
          break;
        case "Home":
          targetTab = this.tabs[0];
          this.focusTab(targetTab);
          e.preventDefault();
          break;
        case "End":
          targetTab = this.tabs[this.tabs.length - 1];
          this.focusTab(targetTab);
          e.preventDefault();
          break;
        default:
          return;
      }
    },
  },
};
</script>

<style scoped>
/* Keep buttons on one line and indicate overflow with ellipsis */
.list-group button {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.active-content {
  white-space: pre-line;
}

/* Note that the color of the tabs can be changed in variables.scss with the following: */
/* $list-group-active-bg: #01256e; */
</style>
